import React, { useMemo } from 'react';
import { Pane } from '@leverege/ui-elements';
import Detail from './Detail';
import S from './CardStyle.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SaleInfoCard(props) {
  const {
    salesperson,
    locatorSalesPrice,
    keysSalesPrice
  } = props;
  const total = useMemo(() => {
    return (locatorSalesPrice || 0) + (keysSalesPrice || 0);
  }, [locatorSalesPrice, keysSalesPrice]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    className: S.container,
    children: /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "dataCard",
      children: [/*#__PURE__*/_jsx(Detail, {
        label: "Salesperson",
        value: salesperson
      }), /*#__PURE__*/_jsx(Detail, {
        label: "Total RecovR Sales Price",
        value: `$${total}`
      })]
    })
  });
}